import { FC } from 'react';
import { Button, Spinner } from "react-bootstrap";
import { t } from 'i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';

interface IProps {
  onClick: (event: any) => Promise<void>;
  disabled?: boolean;
  isLoading?: boolean;
}

const ButtonDelete: FC<IProps> = ({
  onClick,
  isLoading,
  disabled
}) => {
  return (
    <Button
      type="button"
      onClick={(e) => onClick(e)}
      disabled={disabled}
    >
      {isLoading &&
        <Spinner
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      }
      <FontAwesomeIcon icon={faTrashCan} className='me-2' />
      <span>{t("DELETE")}</span>
    </Button>
  );
}

export default ButtonDelete;